module.exports = __webpack_public_path__ + "static/no-data-detail.ef6123fb.png";